<template>
  <div v-if="departmentsList && departmentsList.length" class="text_us_departments mb-4">
    <div v-for="(item, index) in departmentsList" :key="index" class="">
      <div
        class="text_us_departments_card bg-white h-100 custom_box_shadow text-center cursor_pointer  p-3    align-items-center"
        :style="[index === isChecked ? { border: '1px solid' + primaryColor } : { border: '1px solid #fff' }]"
        :class="{ disabledContent: !isLastIndex }" @click.once="eachBodyStyle(item, index)">
        <div class="col-12">
          <p class="mb-0 _theme_font_bold">{{ item.description }}</p>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      departmentsList: [],
      primaryColor: window.primaryColor,
      isChecked: null,
    }
  },

  mounted() {

    if (this.botResponse?.component?.values?.length) {
      this.departmentsList = this.botResponse?.component?.values;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }
  },
  methods: {
    eachBodyStyle(item, index) {
      let specialObject = { TvmComponentRequest: item };
      ChatWidgetService.postTvmMessage(item.description, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction, specialObject);
      this.isChecked = index;
    },
  },

}
</script>
<style lang="less" scoped>
.text_us_departments {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.text_us_departments_card {
  border-radius: 10px;

  &.disabledContent {
    pointer-events: none !important;
    opacity: 0.9 !important;
  }

  .cursor_pointer {
    cursor: pointer;
  }

  small {
    font-size: 15px;
    display: block;
    min-height: 20px;
  }

}
</style>
